import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import * as axios from 'axios';
import * as R from 'ramda';

import { Anticipa } from './anticipa';
import { Facilita } from './facilita';

import { EndPoints } from '../constants/api-config';


export const App = () => {
  // useEffect(() => {
  //   let authToken = sessionStorage.getItem("access_token");
  //   if (!R.isNil(authToken)) {
  //     axios.defaults.headers.common['Authorization'] = "Bearer " + authToken;
  //   }
  // }, []);


  return (
    <React.Fragment>
      <ToastContainer />
      <Switch>
        <Route path="/anticipa/" component={Anticipa} />
        <Route path="/facilita/" component={Facilita} />

        <Route render={() => {
          return <Redirect to="/anticipa/" />;
        }} />
      </Switch>
    </React.Fragment>
  );
};